// extracted by extract-css-chunks-webpack-plugin
module.exports = {"xs":"667.98","sm":"947.98","md":"1023.98","lg":"1229.98","icon":"eWnWO8ci","iconPaintFill":"_0z0usMp9","iconPaintStroke":"wT+PyyEX","iconPlaceholder":"BzPQyzrK"};